/**
 * @Description
 */
import { FC, useEffect, useRef, useState } from 'react';
import Amap from '@/common/components/AMap';
import styles from './index.module.less';
import { isArray, isNotEmptyAny } from '@lhb/func';
import {
  ModelClusterInfo,
  clusterStyleConfig
} from './ts-config';

interface ClusterMapProps {
  clusterInfo: ModelClusterInfo;
}

const ClusterMap: FC<ClusterMapProps> = ({
  clusterInfo
}) => {
  const [mapIns, setMapIns] = useState<any>(null);// 地图实例
  const overlayGroupRef = useRef<any>(null);

  useEffect(() => {
    if (!mapIns || !isNotEmptyAny(clusterInfo)) return;
    createBusinessLayers(clusterInfo);
  }, [mapIns, clusterInfo]);

  // 创建商圈
  const createBusinessLayers = (info: ModelClusterInfo) => {
    if (overlayGroupRef.current) {
      mapIns.remove(overlayGroupRef.current);
      overlayGroupRef.current = null;
    }
    const markers: any = []; // 围栏覆盖物
    const { radius, borders } = info;
    let marker;
    if (radius) {
      marker = createBusinessCircle(info); // 绘制商圈围栏（圆）覆盖物
    } else if (isArray(borders) && borders.length) {
      marker = createBusinessPolygon(info);
    }
    markers.push(...marker);
    const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
    mapIns.add(overlayGroup); // 添加到地图
    marker[0] && mapIns.setFitView(marker[0], false, [30, 30, 30, 30]); // 视口自适应
    overlayGroupRef.current = overlayGroup;
  };

  // 创建多边形商圈
  const createBusinessPolygon = (item: ModelClusterInfo) => {
    const { lng, lat } = item;
    if (!(+lng && +lat)) return;

    const polygon = new window.AMap.Polygon({
      zooms: [12, 20],
      path: item.borders,
      anchor: 'bottom-center',
      bubble: true,
      ...clusterStyleConfig
    });
    return [polygon];
  };

  // 创建圆形商圈
  const createBusinessCircle = (item: ModelClusterInfo) => {
    const { lng, lat } = item;
    if (!(+lng && +lat)) return;
    const lnglat = [+lng, +lat];
    const circle = new window.AMap.Circle({
      zooms: [12, 20],
      center: lnglat,
      radius: item?.radius,
      strokeDasharray: [10, 10],
      bubble: true,
      ...clusterStyleConfig,
    });
    return [circle];
  };

  // 地图加载完成
  const mapLoadedHandle = (ins: any) => {
    ins && setMapIns(ins);
  };

  return <div className={styles.clusterMapWrapper}>
    <Amap
      mapOpts={{
        zooms: [10, 20],
      }}
      loaded={mapLoadedHandle}
    />
  </div>;
};

export default ClusterMap;
